import { TableHeader } from '@portal/frontend/react';
import { formatter } from '@portal/frontend/utils';
import React from 'react';
import { FC } from 'react';
import { Table } from 'react-bootstrap';
import { ReportTableProps } from './ReportTableProps.interface';

export const ProjectWorkitemsTable: FC<ReportTableProps> = ({
  report,
  showCosts,
  showHours,
  noBreakdown,
}) => {
  const colSpan = noBreakdown ? 1 : 3;
  return (
    <>
      {report.length === 0 && <span>This report has no items to display</span>}
      {report.map((project) => {
        return (
          <Table
            bordered
            hover
            size="sm"
            style={{ width: '100%', borderCollapse: 'collapse' }}
            key={project.id}
          >
            <TableHeader
              showHours={showHours}
              showCosts={showCosts}
              noBreakdown={noBreakdown}
            />
            <thead style={{ backgroundColor: '#9FC7E7' }}>
              <tr key={project.id}>
                <th colSpan={colSpan}>
                  {project.name} {project.deletedAt ? '(archived)' : ''}
                </th>
                {showHours && (
                  <th
                    className="font-weight-bold"
                    style={{
                      textAlign: 'right',
                      fontFamily: 'inherit',
                      fontSize: 'inherit',
                      fontWeight: 'normal',
                      width: '1px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {formatter.format(
                      project.workItems
                        .flatMap((workItem) =>
                          workItem.timetableEntries.map((entry) => entry.hours)
                        )
                        .reduce((a, b) => a + b)
                    )}
                  </th>
                )}
                {showCosts && (
                  <th
                    className="font-weight-bold"
                    style={{
                      textAlign: 'right',
                      fontFamily: 'inherit',
                      fontSize: 'inherit',
                      fontWeight: 'normal',
                      width: '1px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {formatter.format(
                      project.workItems
                        .flatMap((workItem) =>
                          workItem.timetableEntries.map(
                            (entry) =>
                              entry.hours * entry.collaborator.role.hourlyRate
                          )
                        )
                        .reduce((a, b) => a + b)
                    )}
                  </th>
                )}
              </tr>
            </thead>
            {project.workItems.map((workItem) => {
              return (
                <React.Fragment key={workItem.id}>
                  <thead style={{ backgroundColor: '#D2E4F3' }}>
                    <tr key={workItem.id}>
                      <th
                        style={{ wordWrap: 'break-word', maxWidth: '1px' }}
                        colSpan={colSpan}
                      >{`#${workItem.extId} ${workItem.name}`}</th>
                      {showHours && (
                        <th
                          className="font-weight-bold"
                          style={{
                            textAlign: 'right',
                            fontFamily: 'inherit',
                            fontSize: 'inherit',
                            fontWeight: 'normal',
                            width: '1px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {formatter.format(
                            workItem.timetableEntries
                              .map((entry) => entry.hours)
                              .reduce((a, b) => a + b)
                          )}
                        </th>
                      )}
                      {showCosts && (
                        <th
                          className="font-weight-bold"
                          style={{
                            textAlign: 'right',
                            fontFamily: 'inherit',
                            fontSize: 'inherit',
                            fontWeight: 'normal',
                            width: '1px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {formatter.format(
                            workItem.timetableEntries
                              .map(
                                (entry) =>
                                  entry.hours *
                                  entry.collaborator.role.hourlyRate
                              )
                              .reduce((a, b) => a + b)
                          )}
                        </th>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {!noBreakdown &&
                      workItem.timetableEntries.map((entry) => {
                        return (
                          <tr key={entry.id}>
                            <td style={{ width: '1px', whiteSpace: 'nowrap' }}>
                              {entry.date}
                            </td>
                            <td style={{ width: '1px', whiteSpace: 'nowrap' }}>
                              {entry.collaborator.employee.name}{' '}
                              {entry.collaborator.employee.surname}
                            </td>
                            <td
                              style={{
                                wordWrap: 'break-word',
                                maxWidth: '1px',
                              }}
                            >
                              {entry.description}
                            </td>
                            {showHours && (
                              <td
                                style={{
                                  width: '1px',
                                  whiteSpace: 'nowrap',
                                  textAlign: 'right',
                                }}
                              >
                                {formatter.format(entry.hours)}
                              </td>
                            )}
                            {showCosts && (
                              <td
                                style={{
                                  width: '1px',
                                  whiteSpace: 'nowrap',
                                  textAlign: 'right',
                                }}
                              >
                                {formatter.format(
                                  entry.hours *
                                    entry.collaborator.role.hourlyRate
                                )}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                  </tbody>
                </React.Fragment>
              );
            })}
          </Table>
        );
      })}
    </>
  );
};
